import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import FichaExpediente from './fichaExpediente';
import ListaTrabajos from './listaTrabajos';
import TipoExpediente from './tipoExpediente';
import Substituciones from "./Substituciones"



class ExpedienteGeneral extends Component {

    render() {

        const disabledEdit = this.props.expediente && this.props.expediente.Trabajos
        && this.props.expediente.Trabajos.some(x => x.Id_Estado >= 3);

        const esSubstitucion = this.props.expediente.Expediente[0].Substitucion;
     
      
        return (
            <Grid container spacing={0}>
              
            <Grid item md={4} xs={12} >

              <FichaExpediente disable={false} expediente={this.props.expediente}
                    sourceExpediente={this.props.expediente.Expediente.length > 0 ? this.props.expediente.Expediente[0] : {}}
                    updateExpediente={(expediente) => this.props.updateExpediente(expediente)} 
                    />        

                {esSubstitucion==1 || !disabledEdit ? 
                     <Substituciones disable={false} expediente={this.props.expediente}
                    sourceExpediente={this.props.expediente.Expediente.length > 0 ? this.props.expediente.Expediente[0] : {}}
                    updateExpediente={(expediente) => this.props.updateExpediente(expediente)}                     
                    />   : null
                    }
                        
                    
            </Grid>  
                  

            <Grid item md={4} xs={12} >
                <TipoExpediente expediente={this.props.expediente} 
                    sourceExpediente={this.props.expediente.Expediente.length > 0 ? this.props.expediente.Expediente[0] : {}} 
                    /> 

            </Grid>



                <Grid item md={4/*6*/} xs={12} >
                <ListaTrabajos
                        changeEstructura={(idTrabajo,idTipoTrabajo) => this.props.changeEstructura(idTrabajo,idTipoTrabajo)}
                        expediente={this.props.expediente} 
                        />
                  
                </Grid>
            </Grid>
        );
    }
}

export default ExpedienteGeneral;